import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { UploadIcon, FileTextIcon, CheckCircleIcon, DownloadIcon, SaveIcon } from 'lucide-react';
export const AnalysisPage: React.FC = () => {
  const [isAnalyzed, setIsAnalyzed] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const handleAnalyze = () => {
    setIsUploading(true);
    setTimeout(() => {
      setIsUploading(false);
      setIsAnalyzed(true);
    }, 2000);
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    // Would handle file upload here
    setIsUploading(true);
    setTimeout(() => {
      setIsUploading(false);
    }, 1500);
  };
  return <div data-id="element-20">
      <h1 className="text-2xl font-bold text-gray-12 mb-8" data-id="element-21">RFQ Analysis</h1>
      <div className="max-w-3xl mx-auto" data-id="element-22">
        {!isAnalyzed ? <Card data-id="element-23">
            <div className={`h-60 rounded-lg border-2 flex flex-col items-center justify-center cursor-pointer transition-all ${isDragging ? 'border-solid border-indigo-9 bg-indigo-2' : 'border-dashed border-gray-7 bg-gray-2 hover:border-indigo-9 hover:bg-indigo-1'}`} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} onClick={() => document.getElementById('file-upload')?.click()} data-id="element-24">
              <input id="file-upload" type="file" className="hidden" accept=".pdf,.docx" data-id="element-25" />
              <FileTextIcon size={48} className={isDragging ? 'text-indigo-9 mb-4' : 'text-gray-9 mb-4'} data-id="element-26" />
              <p className="text-gray-11 font-medium mb-2" data-id="element-27">
                {isUploading ? <span className="flex items-center" data-id="element-28">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-indigo-9" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-29">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-30"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-31"></path>
                    </svg>
                    Uploading file...
                  </span> : <>
                    <UploadIcon size={16} className="inline mr-1" strokeWidth={2.5} data-id="element-32" />{' '}
                    Drop file here
                  </>}
              </p>
              <p className="text-gray-10 text-sm" data-id="element-33">or click to browse</p>
              <p className="text-gray-10 text-xs mt-4" data-id="element-34">
                Supports: PDF, Word (.docx)
              </p>
              <p className="text-gray-10 text-xs" data-id="element-35">Max size: 10MB</p>
            </div>
            <div className="mt-6 flex justify-center" data-id="element-36">
              <Button onClick={handleAnalyze} isLoading={isUploading} disabled={isUploading} data-id="element-37">
                Analyze Document
              </Button>
            </div>
          </Card> : <Card data-id="element-38">
            <div className="flex items-center justify-between mb-6" data-id="element-39">
              <h2 className="text-lg font-semibold text-gray-12" data-id="element-40">
                Analysis Results
              </h2>
              <div className="flex items-center text-sm text-green-11" data-id="element-41">
                <CheckCircleIcon size={16} className="mr-1" data-id="element-42" />
                Analysis Complete
              </div>
            </div>
            <div className="space-y-6" data-id="element-43">
              <div data-id="element-44">
                <h3 className="text-base font-semibold text-gray-12 mb-2" data-id="element-45">
                  Key Information:
                </h3>
                <ul className="text-sm text-gray-11 space-y-1 ml-1" data-id="element-46">
                  <li data-id="element-47">• Deadline: December 15, 2024</li>
                  <li data-id="element-48">• Budget: $2.5M - $3.0M</li>
                  <li data-id="element-49">• Location: Denver, CO</li>
                  <li data-id="element-50">• Project Type: Commercial Office</li>
                </ul>
              </div>
              <div data-id="element-51">
                <h3 className="text-base font-semibold text-gray-12 mb-2" data-id="element-52">
                  Requirements:
                </h3>
                <ol className="text-sm text-gray-11 space-y-1 ml-4 list-decimal" data-id="element-53">
                  <li data-id="element-54">LEED Gold Certification</li>
                  <li data-id="element-55">50,000 sq ft minimum</li>
                  <li data-id="element-56">10+ years experience required</li>
                  <li data-id="element-57">Local presence in Colorado</li>
                </ol>
              </div>
              <div data-id="element-58">
                <h3 className="text-base font-semibold text-gray-12 mb-2" data-id="element-59">
                  Scope of Work:
                </h3>
                <ul className="text-sm text-gray-11 space-y-1 ml-1" data-id="element-60">
                  <li data-id="element-61">• Architecture and design services</li>
                  <li data-id="element-62">• MEP engineering coordination</li>
                  <li data-id="element-63">• Construction administration</li>
                </ul>
              </div>
              <div className="flex space-x-3 pt-4 mt-4 border-t border-gray-6" data-id="element-64">
                <Button variant="secondary" icon={<DownloadIcon size={16} data-id="element-66" />} data-id="element-65">
                  Export PDF
                </Button>
                <Button icon={<SaveIcon size={16} data-id="element-68" />} data-id="element-67">Save to Pursuit</Button>
              </div>
            </div>
          </Card>}
      </div>
    </div>;
};